/**
 * Normalise a Contentful Page slug for client routing (Blog Listing, CF-050, Search).
 *
 * @param {string|null|undefined} pageSlug - Raw Page.slug from Contentful
 * @returns {string} Path with leading slash, or empty string when missing
 */
export function formatBlogPageSlug(pageSlug) {
  const slug = String(pageSlug || '').trim();

  if (!slug) {
    return '';
  }

  return slug.startsWith('/') ? slug : `/${slug}`;
}

/**
 * Build blog sys.id → formatted page slug map from blogCollection linkedFrom results.
 *
 * @param {Array<{sys?: {id?: string}, linkedFrom?: {pageCollection?: {items?: Array<{slug?: string}>}}}>|null|undefined} blogs
 * @returns {Map<string, string>}
 */
export function buildBlogPageSlugMap(blogs = []) {
  const map = new Map();

  for (const blog of blogs) {
    const blogId = blog?.sys?.id;
    const rawSlug = blog?.linkedFrom?.pageCollection?.items?.[0]?.slug;
    const formattedSlug = formatBlogPageSlug(rawSlug);

    if (blogId && formattedSlug) {
      map.set(blogId, formattedSlug);
    }
  }

  return map;
}
